class AddressBook {
    static BOOK = {
        // Mainnet Pools
        'NQ48 8CKH BA24 2VR3 N249 N8MN J5XX 74DB 5XJ8': 'Skypool',
        'NQ58 U4HN TVVA FCRS VLYL 8XTL K0B7 2FVD EC6B': 'Skypool Gundam',
        'NQ88 D1R3 KR4H KSY2 CQYR 5G0C 80X4 0KED 32G8': 'Skypool Bebop',
        'NQ43 GQ0B R7AJ 7SUG Q2HC 3XMP MNRU 8VM0 AJEG': 'Skypool Pandaman',
        'NQ74 FLQL DRE3 99PF CET0 3N7D JKLF MQP6 87KS': 'Skypool SamuraiChamploo',
        'NQ46 UTKP D8A9 04RS A1LL GPR8 BE4L G2BD FYSX': 'Skypool Hehe',
        'NQ32 473Y R5T3 979R 325K S8UT 7E3A NRNS VBX2': 'SushiPool',
        'NQ89 T8SS SE0B SS5L GRH0 J849 LQ0L 3J6N RAFU': 'SushiPool',
        'NQ76 R7R0 DCKG N0RC 35XK ULTS N41J VGA7 3CMP': 'Porky Pool',
        'NQ10 76JC KSSE 5S2R U401 NC5P M3N2 8TKQ YATP': 'Nimiqchain.info Pool',
        'NQ33 DH76 PHUK J41Q LX3A U4E0 M0BM QJH9 QQL1': 'Beeppool',
        'NQ90 P00L 2EG5 3SBU 7TB5 NPGG 8FNL 4JC7 A4ML': 'NIMIQ.WATCH Pool',
        'NQ11 P00L 2HYP TUK8 VY6L 2N22 MMBU MHHR BSAA': 'Nimpool.io',
        'NQ04 3GHQ RAV6 75FD R9XA VS7N 146Q H230 2KER': 'Nimiqpool.com',
        'NQ07 SURF KVMX XF1U T3PH GXSN HYK1 RG71 HBKR': 'Nimiq.Surf',
        'NQ90 PH1L 7MT2 VTUH PJYC 17RV Q61B 006N 4KP7': 'PhilPool',
        'NQ06 NG1G 83YG 5D59 LK8G Y2JB VYTH EL6D 7AKY': 'Nimbus Pool',
        'NQ18 37VM K2Y5 2HPY 5U80 2E0U VHUJ R7RK QSNE': 'Sirius Pool',
        'NQ64 55BR 87SX AFHN XB27 M7BQ F7CY L4FV 2TG2': 'HexaPool',
        'NQ67 AQB4 RHCC AU2T 4CC0 ETUT X1XB SSFL V9UQ': 'mineNIM Pool',
        'NQ37 47US CL1J M0KQ KEY3 YQ4G KGHC VPVF 8L02': 'Nimiqpocket Pool',
        'NQ24 900S EKCD HGDA TN30 8UET LX2F 75U1 G1A1': 'Nimiqo.com',
        'NQ88 QEC9 5MDH T2SB V70A GB76 MGRT STSB LN9A': 'X Pool',
        'NQ04 XEHA A84N FXQ4 DPPE 82PG QS63 TH1X XCHQ': 'icemining.ca',
        'NQ43 FGFD 5GFC LVR2 VBEG FVRH RGEQ MY66 1EXE': 'Cuckoo Pool',
        'NQ39 4QEH 96PD CRRH GVJ8 DJX5 A4FU 30KU M38G': 'Euro Nimiq Pool',
        'NQ46 A8DL P003 VJH4 N2FS VQM6 5VB3 38VA DNCS': 'URP_Mining',
        'NQ98 GG96 VCBY 2P1N UYK6 BU71 1UU7 SMUP KT8X': 'zeliboooba.ga',
        'NQ98 NKJM 9EVQ PXE5 B7PV GHK1 V5K2 P5HK R6JY': 'syss.ml',
        'NQ53 FREE P00L K329 X0GV 8K8C 34HB Y1Q9 48B7': 'FuguPool',
        'NQ59 H4E7 VHKX EEJG FLT2 A41A 4A6P PGCN 87N9': 'BalkanMiningPool',
        'NQ33 F625 YNJ8 KUKM P5PH XHSH A68H 8NBE 8TV4': 'BlankPool',
        'NQ73 5YST L539 X4PR 079G KXS4 5LM8 X0EG 49AR': 'HashExpress Pool',
        'NQ46 CFSH QGJG BEBT JFTC TTNR C7SV 59JP 69HJ': 'Micro Pool',
        'NQ64 3GHE KLVF G5KT EM66 8CTX M7U3 3P6G CVXS': 'Consensus Protocol Pool',
        'NQ72 MG1Y E8F2 EBH9 3NVH 1HBY ATRE 26TS MH19': 'AceMining Pool (old)',
        'NQ74 547S YUM1 UEXY HT88 21T0 KG8H 9B6T SPKT': 'AceMining Pool',
        'NQ97 QG2U YL9L 4NVG H18B 24B6 CYM3 75VJ FT73': 'HashExpress',
        'NQ52 5XQ7 P24G B8E6 J8RM PP26 5XXR GT6Y ALEK': 'Urkel Pool',
        'NQ76 ERYJ B75G 8QJ1 YFN3 VRKV RTYJ NTY4 NLH9': 'das3990x',
        'NQ33 P6CJ 15C8 RC8F KFXK LPCU C36A RNVB GHYT': 'LoloPool',
        'NQ27 CH2H Q8NK M9BL QYF5 K5X6 KFR8 76TL DHUX': 'das3990x',
        'NQ13 J666 L991 VVJ4 X3D2 77LL Y9Y9 A615 0YVG': 'das3990x',
        'NQ87 RP5U 72J8 5N5K JUDE HGVU VYHX QM37 23V4': 'Minet',
        'NQ36 M4KK FC8H 8M5A 9BCK LTP1 KEVQ 1XAA C6V5': 'mcpool',
        'NQ21 YDBK D4LV QCY7 1AC2 N1TA YG3G 7X72 GRL4': 'mcpool',
        'NQ72 SP61 6SXJ 1K6G 74TV XNB4 ATQP M2KP V657': 'Coinhunters Pool',
        // Mainnet Services
        'NQ15 MLJN 23YB 8FBM 61TN 7LYG 2212 LVBG 4V19': 'NIM Activation',
        'NQ09 VF5Y 1PKV MRM4 5LE1 55KV P6R2 GXYJ XYQF': 'Nimiq Foundation',
        'NQ19 YG54 46TX EHGQ D2R2 V8XA JX84 UFG0 S0MC': 'Nimiq Charity',
        'NQ93 RL4N M68G 9DEN CKU9 HJRE HYRJ CYRE J0XB': 'nimiqfaucet.io',
        'NQ94 GSXP KNG0 K5YV HFJ1 PYAQ Y5D1 XTQ1 SLFP': 'Nimiq-Faucet.surge.sh',
        'NQ80 PAYN R93R D0H4 BH8T KPRT SBYE 30A3 PHDL': 'PayNim.app',
        'NQ85 TEST VY0L DR6U KDXA 6EAV 1EJG ENJ9 NCGP': 'Discord NIM Tip Bot',
        'NQ26 NMK7 R4EA KSV2 67Q2 5L4T DVDS FR5E NX7B': 'Nimiq Shop',
        'NQ24 458E 67E1 C90M C0XQ 146B CE6R JMYR E27S': 'Nimiq Shop',
        'NQ02 YP68 BA76 0KR3 QY9C SF0K LP8Q THB6 LTKU': 'Nimiq Faucet',
        'NQ23 3RK3 U8KF 72NS SPNX H0R3 E9HQ 68AB SHAQ': 'Nimbet.cc',
        'NQ07 R0NG UTD5 P187 6YLK CD3H EMGF EDAC LFUS': 'GetNIM (discontinued)',
        'NQ81 J9XR VM0N T9Q7 EC44 B910 QSKU 0G3Y S80Q': 'GetNim.io',
        'NQ91 B9E4 1FTS PV33 9NTJ H1PE NYDE 0M36 CMLT': 'Nimiq TrustWallet Faucet',
        'NQ57 66QM QFT0 QQX8 1QSL 820V XDN1 1C82 1M2B': 'Bidali Giftcards',
        'NQ69 R83V YQXR L0LF YPEY 11KH SKX9 T7BY CBVH': 'Nimtris',
        'NQ41 V0TE UCSX NF24 BGKQ 8B7R RNVE FRMH NUJH': 'Curve Change Vote (May 2020)',
        'NQ84 V0TE 5EH3 UT5S 67UV SQL0 AUS8 NEKS 2K7B': 'Curve Ranking Vote (June 2020)',
        'NQ53 SQNM 36RL F333 PPBJ KKRC RE33 2X06 1HJA': 'Fastspot Demo',
        'NQ36 71PB 0TXY AUA9 JG2Y 2JQG PQBF YSVK KNTA': 'NIM TIP BOT',
        'NQ97 QTDN Q3P7 71A5 56YN NKRN 5S1B 6QNJ 0FBE': 'Noviopay-DEMO',
        'NQ70 55N0 8G9K L0V8 XVUB 5L3H H8RK 0TBR MQF6': 'Tips.me',
        'NQ24 M0PS USES AJF6 9GQX 7C64 3E3F DYGF 6QP5': 'Mopsus Block Explorer',
        'NQ55 VDTM 6PVT N672 SECN JKVD 9KE4 SD91 PCCM': 'Nim.sh',
        'NQ60 JEN9 1QFN 5C00 NPHR 9AL0 TT09 4VFL 7X0E': 'Nimiq Lottery',
        'NQ20 8P9L 3YMD GQYT 1TAA 8D0G MC12 5HBQ 1Q8A': 'Nimiq Sunset Cyberspace',
        'NQ31 FVDG LE5U 9RC9 77KQ EAN5 YP9V G999 X535': 'Dinarpay.net',
        'NQ35 YGH5 41TT R77B 61S6 UP7L XC0M S0D2 GDFL': 'tip.cc',
        'NQ56 VE9K PV0Y TK4T QBMY 8E9G B85J QR6M MSHL': 'Fastspot GO',
        'NQ04 PMCY 8ETQ TN8M 42NF M497 LCPM F215 T6CU': 'Nimiq Vouchers',
        'NQ23 6CYY 7AJG AM08 Y5G5 MHGX 6U4U 270A 7SH0': 'OASIS Fee Buy-Back',
        'NQ38 KCJ8 X2JK LEEH 4HYL 7D61 3T3P RCNG GJ2C': 'NimiqX',
        'NQ69 GTPG 0RCT GR2S E90G 60EV X65X H2KH BQLL': 'NimClick',
        'NQ45 B9ST N7CS 2GKJ T9NM 615G H1RG 25UE AD3D': 'nim.drawpad.org/n/',
        'NQ69 SUJP 7U2H 07UP QS79 NJ12 GTXS 62MG T04H': 'NimLand.xyz',
        'NQ69 LK52 01U1 E4AM TN1E 8HKL Y5FL M90D UJX8': 'SurverysForNimiq',
        'NQ24 PUP8 Y8H4 CFP0 RPYR FP93 TV12 UMY0 LTP5': 'DutchyFaucet',
        'NQ80 KBXG 5HQ1 5R0D E9GC B9SG 38SD 318J NPUP': 'Nimiq Squad',
        // Exchanges
        'NQ81 846T N9DB TD11 VJTU C7UP JLAH M6QQ 6UPB': 'HitBTC',
        'NQ55 UE76 E517 CKDR MADX 6SY9 PR70 K1XE FHM1': 'HitBTC Cold Wallet',
        'NQ57 EMG8 S4QY GE3B K4CB MQ4E 0SUS 6UT9 JFC0': 'TradeSatoshi',
        'NQ89 AAMN QJFF 7RKS 4XX0 EFXN M4QG 4MYH HMBJ': 'Changelly',
        'NQ13 XAME QAMX 3302 13E3 ECXQ HU88 TM6R YKVK': 'KuCoin (old, do not send!)',
        'NQ16 HP6H 5CHC QQMD 5BE3 AFCQ QUJ9 4451 NKSM': 'KuCoin (old, do not send!)',
        'NQ27 B9ED 98G5 3VH7 FY8D BFP0 XNF4 BD8L TN4B': 'KuCoin (old, do not send!)',
        'NQ04 B79B R4FF 4NGU A9H0 2PT9 9ART 5A88 J73T': 'KuCoin Cold',
        'NQ68 HPHJ 8RQU F48M 7S3L RF6D JVAC N2J4 S8A7': 'KuCoin',
        'NQ66 QDMD SRPT B2A4 JBGJ 30M6 LBPN EK9N LR74': 'HotBit',
        'NQ17 1XMK VKC4 BHAA QH1X TH6G NC3V 40RH 8GN2': 'ChangeHero',
        'NQ37 KVUA EHER E5VA C7M0 1PF5 YBRA GE5C RB6K': 'ChangeHero',
        'NQ68 J3A4 1NXK DXCE GFBJ 24P7 XH7K 06GB 6GFV': 'Bitladon',
        // Testnet
        'NQ31 QEPR ED7V 00KC P7UC P1PR DKJC VNU7 E461': 'pool.nimiq-testnet.com',
        'NQ36 P00L 1N6T S3QL KJY8 6FH4 5XN4 DXY0 L7C8': 'NIMIQ.WATCH Testnet-Pool',
        'NQ50 CXGC 14C6 Y7Q4 U3X2 KF0S 0Q88 G09C PGA0': 'SushiPool TESTNET',
        'NQ26 XM1G BFAD PACE R5L0 C85L 6143 FD8L 82U9': 'Nimiq Shop (Testnet)',
        'NQ76 F8M9 1VJ9 K88B TXDY ADT3 F08D QLHY UULK': 'Nimiq Bar (Testnet)',
        'NQ54 8LN7 9DX7 XG20 1XK8 GGGT Y2UU 2DDT BKLV': 'UberPool (Testnet)',
        'NQ17 D2ES UBTP N14D RG4E 2KBK 217A 2GH2 NNY1': 'Fastspot (Testnet)',
        'NQ12 0XL5 5KUC 7LAM NUNA 59BV XE4K 6SDT 5E0A': 'ROYAL NIM CASINO (Testnet)',
        'NQ60 29BE CJUY U9PA GNNE RTXC HF6K C8D3 K36L': 'Nimiq Lottery (Testnet)',
    };
    static getLabel(address) {
        return AddressBook.BOOK[address] || null;
    }
}

export { AddressBook };
//# sourceMappingURL=AddressBook.js.map
